import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class MovuRobotics_ds_get_load_container_details_for_activate_shipment_by_loadContainerIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { loadContainerId?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Notes?: string, Priority?: number, Shipments?: { Id?: number, ContainerIdentifier?: string, LookupCode?: string, LicensePlates?: { Id?: number, LookupCode?: string, Location?: { Id?: number, Name?: string } }[] }[] } }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      loadContainerId?: number    }) {
      return false;
    }
}
